import React, { useEffect, useState } from 'react';
import TransferForm, { DEFAULT_DATA, k_transfer_form_data } from '../../components/transfer/TransferForm';
import { useNavigate } from 'react-router';
import { createSelector } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import { Selector } from '@utils/constants';
import ActivitiesGrid from '../../components/activity/ActivitiesGrid';

function TransfersHomePage() {
    const jsonString = sessionStorage.getItem(k_transfer_form_data);
    const inintData = JSON.parse(jsonString) || DEFAULT_DATA;
    const [data, setData] = useState(inintData);
    const navigate = useNavigate();

    // Redux Memoized Selectors
    const selectorData = (state) => state.activities.data;
    const filterHiden = createSelector(selectorData, (items) => items?.filter((item) => item.hidden == false));
    const activities = useSelector((state) => {
        return filterHiden(state);
    });
    const fetching = useSelector((state) => state.activities.fetching);
    const [transferActivties, setTransferActivties] = useState([]);

    useEffect(() => {
        const jsonString = sessionStorage.getItem(k_transfer_form_data);
        const inintData = JSON.parse(jsonString) || DEFAULT_DATA;
        setData(inintData);
    }, []);

    useEffect(() => {
        filterActivities();
    }, [fetching]);

    useEffect(() => {
        console.log('data changed', data);
        sessionStorage.setItem(k_transfer_form_data, JSON.stringify(data));
        return () => {};
    }, [data]);

    const filterActivities = () => {
        const fixedSelector = Selector.Transfers;
        let newData = [...activities];
        // Fixed selector
        newData = activities.filter((item) => {
            if (item.selectors?.includes(fixedSelector)) {
                return true;
            }
        });
        // Selector sorting
        newData?.sort((a, b) => {
            const sortA = a.selectorItems.find((item) => item.name == fixedSelector).sort;
            const sortB = b.selectorItems.find((item) => item.name == fixedSelector).sort;
            return sortA - sortB;
        });
        setTransferActivties(newData);
    };

    const handleSubmit = (data) => {
        console.log('Submitted data:', data);
        const searchParams = new URLSearchParams(data);
        console.log('Search params:', searchParams.toString());
        navigate(`vehicles?${searchParams.toString()}`);
    };

    return (
        <div>
            <div style={{ fontSize: 18, fontWeight: 500, padding: '16px 0' }}>用车(机场接送/按时包车)</div>
            <div>
                <TransferForm data={data} setData={setData} onSubmit={handleSubmit} />
            </div>
            {fetching && <div>Loading...</div>}
            <h3>合约商家(节省 50% 车费)</h3>
            <div style={{ padding: '16px 0' }}>
                <ActivitiesGrid activities={transferActivties} isFromPrice={true} />
            </div>
        </div>
    );
}

export default TransfersHomePage;
